import { connect } from "react-redux";
import SalidaProductos from "./SalidaProductos";
import {
    listar,
    buscar,
    sortChange,
    agregar,
    agregarPrimer,
    quitar,
} from "../../../../redux/modules/bodega/bodega";

import { actions } from "../../../../redux/modules/bodega/salida_producto";

const mapStateToProps = (state) => {
    const conf_tipo_negocio =
        state.configuracion && state.configuracion.config
            ? state.configuracion.config.conf_tipo_negocio
            : null;

    return {
        ...state.bodega,
        sucursal: state.usuario.sucursal,
        loader: state.bodega.loader,
        data: state.bodega.data,
        page: state.bodega.page,
        seleccionados: state.bodega.seleccionados,
        search: state.bodega.search,
        conf_tipo_negocio,
    };
};

const mapDispatchToProps = {
    listar,
    buscar,
    agregar,
    sortChange,
    agregarPrimer,
    quitar,
    ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(SalidaProductos);
